module.exports = __webpack_public_path__ + "img/contentinfo3.fed09e47.png";